import React from 'react'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import './ModalComp.css';
import {FaFacebook} from 'react-icons/fa';
import {FcGoogle} from 'react-icons/fc';
import {MdEmail} from 'react-icons/md';
import {AiOutlineClose} from 'react-icons/ai'
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 0,
  };

const ModalComp = ({openModal,setOpenModal}) => {

    return (
        <div>
        <Modal
          open={openModal}
          className='a'
          onClose={()=>setOpenModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style} className='a'>
            <div className='modalHeader'>
              <AiOutlineClose className='modalIcon' />
              <span className='modalTitle'>Log in or sign up</span>
            </div>
            <hr />
            <div className='modalSecSubDiv'>
            <h2>Welcome to Airbnb</h2>
            <div className='enterEmail'>
            <span>Email</span>
            <input className='emailInput' placeholder='Email' />
            </div>
            <div className='continueDiv'>
                <span>Continue</span>
            </div>
            <div className='fbDiv'>
               <FaFacebook className='modalIcon'/> <span>Continue with Facebook</span>
            </div>
            <div className='fbDiv'>
            <FcGoogle className='modalIcon'/> <span>Continue with Google</span>
            </div>
            <div className='fbDiv lastDiv'>
               <MdEmail className='modalIcon'/> <span>Continue with Email</span>
            </div>
            </div>
          </Box>
        </Modal>
      </div>
  )
}

export default ModalComp